export default __webpack_public_path__ + "media/images/ticketlogo-8aa340c4259ffcdb1afff895cbde77fd.gif";